import { computed, defineComponent, PropType, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";

export default defineComponent({
  name: "UsersSearchController",
  props: {
    relevantTerm: { type: String, default: "" },
    tags: { type: Array as () => string[], default: () => [] },
    languages: { type: Array as PropType<string[]>, default: () => [] },
    locations: { type: Array as PropType<UserLocation[]>, default: () => [] },
  },
  setup(props) {
    const { render, getFirstPage } = useUserPublicData(
      computed(() => ({
        role: "creator",
        discoveryOnly: true,
        tags: props.tags.length ? props.tags : undefined,
        locations: props.locations?.length ? props.locations : undefined,
        languages: props.languages?.length ? props.languages : undefined,
        relevantTerm: props.relevantTerm ? props.relevantTerm : undefined,
        disabled: false,
      })),
      undefined,
      userPublicDataFieldsWithStoryInfo()
    );

    watch(
      toRef(props, "relevantTerm"),
      debounce((newValue, oldValue) => {
        if ((!!newValue && newValue !== oldValue) || (!newValue && !!oldValue)) {
          getFirstPage();
        }
      }, 500),
      {
        immediate: true,
      }
    );

    watch(
      [toRef(props, "tags"), toRef(props, "locations"), toRef(props, "languages")],
      debounce((newValue, oldValue) => {
        if (
          (newValue.length && ((!!oldValue && newValue.toString() !== oldValue.toString()) || !oldValue)) ||
          (!newValue.length && !!oldValue && oldValue.length)
        )
          getFirstPage();
      }, 500),
      {
        immediate: true,
      }
    );

    return render;
  },
});
